
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".7","x":".5","y":".5","width":"29","height":"29","rx":"4.5","stroke":"#C7C7C7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.554 5.287a.98.98 0 011.386 0l2.773 2.773a.98.98 0 010 1.386L11.685 22.474a.98.98 0 01-.329.216l-5.683 2.274a.49.49 0 01-.637-.637l2.273-5.683a.98.98 0 01.217-.33L20.554 5.288zm-.025 1.411a1.015 1.015 0 011.436 0l1.337 1.337c.396.396.396 1.04 0 1.436l-1.362 1.361-2.772-2.772 1.361-1.362zm-2.054 2.055l2.772 2.772-9.704 9.705-2.773-2.773 9.705-9.704zM7.178 21.612a.931.931 0 001.21 1.21l2.4-.96-2.65-2.651-.96 2.4z","fill":"#9B9B9B"}})])
          )
        }
      }
    